import { render, staticRenderFns } from "./Service-content.vue?vue&type=template&id=3dc5a480&scoped=true"
var script = {}
import style0 from "./Service-content.vue?vue&type=style&index=0&id=3dc5a480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5a480",
  null
  
)

export default component.exports